import React from 'react';
import { css } from '@emotion/react';
import InfoIcon from '../../../OC/oc-info-icon';

const tooltip = css`
  position: relative;
  z-index: 999;

  .tooltipContent {
    position: absolute;
    width: 150px;
    background: white;
    border: 1px solid #e6e6e6;
    left: -165px;
    top: -40px;
    box-shadow: rgba(0, 0, 0, 0.16) 0px 1px 4px;
    border-radius: 5px;
    opacity: 0;
    transition: all 0.5s ease;

    .head {
      background: #e6e6e6;
      padding: 2px 5px;
      border-bottom: 1px solid #e6e6e6;
    }

    .headText {
      font-size: 12px;
      font-weight: bold;
      color: #000;
    }

    .content {
      padding: 0 5px;

      p {
        font-size: 12px;
      }
    }

    &:before {
      content: '';
      position: absolute;
      pointer-events: none;
      left: 141px;
      top: 39px;
      -webkit-transform: rotate(45deg);
      -moz-transform: rotate(45deg);
      -ms-transform: rotate(45deg);
      transform: rotate(45deg);
      -webkit-transition: all 0.3s ease;
      transition: all 0.3s ease;
      transition-delay: 1.2s;
      width: 15px;
      height: 15px;
      border-top: 1px solid #e6e6e6;
      border-right: 1px solid #e6e6e6;
      background: white;
    }
  }

  .iconHover {
    &:hover {
      .tooltipContent {
        opacity: 1;
        transform: translate3d(-50%, calc(-100% - 18px), 0);
      }
    }
  }
`;

const Tooltip = ({ title, info }) => {
  const handleHover = (event, opacity) => {
    const tooltipEle = event.currentTarget.nextElementSibling;
    tooltipEle.style.opacity = opacity;
  };

  return (
    <div css={tooltip}>
      <span
        onMouseOver={event => handleHover(event, 1)}
        onMouseLeave={event => handleHover(event, 0)}
        className="iconHover"
      >
        <InfoIcon />
      </span>
      <div className="tooltipContent">
        <div className="head">
          <span className="headText">{title}</span>
        </div>
        <div className="content">
          <p>{info}</p>
        </div>
      </div>
    </div>
  );
};

export default Tooltip;
